import getHelper from '../../../services/getHelper';
import type { TokenResponse } from '../types';

export default getHelper<TokenResponse>('/tokens/:id');
